export default function (slotScene, bonusScene, parent, $ticker) {
    const space = parent.child("bonus");
    
    if (!bonusScene) {
        return {
            space
        };
    }
    
    if ( bonusScene.update )
    {
        $ticker.subscribe(dt => {
            bonusScene.update(dt);
        });
    }
    
    //
    // space.s("start").subscribe(info => {
    //     // slotScene.visible = false;
    //     bonusScene.visible = true;
    //     bonusScene.resume(info);
    // });
    //
    //
    space.s("end").subscribe(stageMath => {
        
        console.warn('BONUS:END');
        
        slotScene.visible = true;
        slotScene.resume();
        
        bonusScene.pause();
        bonusScene.visible = false;
    });
    
    const $beginComplete = space.s("beginComplete");
    
    // скрываем приглашение в бонусы
    space.s("begin").subscribe(info => {
        slotScene.hideBonusTable(() => {
            slotScene.pause();
            slotScene.visible = false;
            $beginComplete.next();
        });
    });
    
    
    const $endingComplete = space.s("endingComplete");
    
    // показ таблички после бонуса (сцена сама разберется что ей надо в этих данных)
    space.s("ending").subscribe( ({ math, bet }) => {
        console.warn('BONUS:ENDING');
        
        bonusScene.showFinishTable(
            math,
            bet,
            () => $endingComplete.next()
        );
    });
    
    // способ передачи в движок варианта выбора, который был сделал тычком по элементу сцены
    // если игрок выбирал через F-клавишу то это обрабатывается в движке
    const $bonusSelection = space.s("selection");
   
    const f = variant => {
        $bonusSelection.next(variant);
    };
    
    if ( bonusScene.setOnUserSelect ) bonusScene.setOnUserSelect( f )
    
    // пользователь сделал выбор - дальше идет длительная сетевая операция
    // выборы пока делать нельзя ДВИЖОК ДОЛЖЕН ЭТО ЗНАТЬ!!!!
    // (что именно выбрал игрок отобразится в методе, ответственом за показ данных от сервера)
    space.s("selectionHasMade").subscribe(variant => {
        bonusScene.selectionHasMade(variant);
    });
    
    // выбор (не важно каким путем он сделан) блокирует сцену пока не покажестя исход шага бонуса
    space.s("selection").to(space.s("selectionHasMade"));
    
    
    const $displayComplete = space.s( "displayComplete" )
        .description('bonus step iteration has been shown');
    
    // получены данные от сервера с исходом бонуса и выбором который сделал игрок
    // TODO: кроме того здесь нужны данные - кредиты, ставка, выигрыш (предыдущего стейта)
    space.s("showResult").subscribe( data => {
        bonusScene.visible = true;

        bonusScene.showResult(data, ()=>{
            console.warn('BONUS:SHOW RESULT DONE');
            $displayComplete.next();
        });
    });
    
    return {
        space
    };
}


// WEBPACK FOOTER //
// ./src/library/bonus_view.es6